<template>
  <ValidationProvider
    v-slot="{ errors, valid }"
    :name="validation_label"
    :rules="validation_rules"
  >
    <v-textarea
      v-model="val"
      :flat="forResetEmail"
      :solo="forResetEmail"
      dense
      color="primary"
      :disabled="!editable"
      :filled="editable"
      :error-messages="errors"
      :success="valid"
      :placeholder="placeholder"
      @input="$emit('onInput', { name, value: val })"
      :no-resize="isResize"
    ></v-textarea>
  </ValidationProvider>
</template>
<script>
import { ValidationProvider } from "vee-validate";
export default {
  components: {
    ValidationProvider,
  },
  props: {
    editable: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
    },
    values: {
      type: Object,
    },
    validation_rules: {
      type: String,
    },
    validation_label: {
      type: String,
    },
    placeholder: {
      type: String,
      default: "",
    },
    isForResetEmail: {
      type: Boolean,
      default: false,
    },
    isResize: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      val: "",
    };
  },
  mounted() {
    this.$watch(
      () => [this.values, this.name],
      (newValue) => {
        const formValues = newValue[0];
        const name = newValue[1];
        if (formValues && name) this.val = formValues[name];
      },
      { immediate: true, deep: true }
    );
  },
  computed: {
    forResetEmail() {
      return this.isForResetEmail == true ? true : false;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/themes.scss";

.v-textarea ::v-deep .v-input__slot {
  border: 1px solid $border_color;
  border-radius: 5px;
  color: $border_color;
  background-color: $primary_color !important;
  box-shadow: 0 5px 10px $shadow_color;
}
.v-textarea ::v-deep .v-input__slot:before {
  border-color: transparent !important;
}
.v-textarea ::v-deep textarea::placeholder {
  color: $placeholder_color !important;
}
.v-input--is-focused ::v-deep textarea::placeholder {
  opacity: 0;
}
::v-deep .v-input--is-disabled .v-input__slot {
  padding: 6px 12px !important;
  background-color: transparent !important;
  box-shadow: none !important;
  border: none;
}
</style>
